export class AppNotification {
    constructor(
        public title: string = null,
        public message: string = null,
        public foreground: boolean = false,
    ) {}
}